import { Component, OnInit, ViewEncapsulation, trigger, state, animate, transition, style } from '@angular/core';
import { Router, Route } from '@angular/router';
import { ResponsoveService } from './commons/responsive.service';
import { SessionService } from './commons/session.service';
import { CartService } from './commons/cart.service';
import { ConfigService } from './commons/config.service';
import { ScrollService } from './commons/scroll.service';
import { UtilitiesService } from './commons/utilities.service';
import { ConfiguratorApiService } from './commons/configurator-api.service';
import { ActivatedRoute, Params, NavigationEnd, Event } from '@angular/router';

import { Angulartics2GoogleAnalytics, Angulartics2, Angulartics2Facebook } from 'angulartics2';

declare var _gaq: any;
declare var ga: any;


@Component({
  selector: 'my-app',
  encapsulation: ViewEncapsulation.None, // questo elimina il Shadow DOM per questo componente
  template: require('./app.component.html'),
  styles: [require('./app.component.scss')],
  animations: [
    trigger('AnimationSlide', [
      state('inactive', style({ left: '-110%' })),
      state('active', style({ left: '0' })),
      transition('inactive <=> active', animate('400ms cubic-bezier(0.5,-0.6,0.5,1.6)'))
    ])
    ,
    trigger('OpenShowSlide', [
      state('inactive', style({ left: 'calc(-100% - 25px)' })),
      state('active', style({ left: '0' })),
      transition('inactive <=> active', animate('400ms cubic-bezier(0.5,-0.6,0.5,1.6)'))
    ])
  ]
})

export class AppComponent implements OnInit {

  footer: any;
  minHeight: number;
  classe: string = 'active';
  media: string = 'xs';
  isXS: boolean = false;


  public RouteMenu: Route[];
  public table: string;
  public showHideNav: boolean = false;

  constructor(
    public session: SessionService,
    public router: Router,
    private responsive: ResponsoveService,
    public cartService: CartService,
    private scroll: ScrollService,
    private configApi: ConfiguratorApiService,
    public config: ConfigService,
    public utilities: UtilitiesService,
    private activatedRoute: ActivatedRoute,

    public angulartics2: Angulartics2,
    public angulartics2GoogleAnalytics: Angulartics2GoogleAnalytics,
    public angulartics2Facebook: Angulartics2Facebook
  ) { }

  changeShowStatus() {
    this.showHideNav = !this.showHideNav;
  }

  sendAnalytics() {

    let newRoute = window.location.href.replace(this.config.urlHost, '/');
    ga('send', 'pageview', newRoute);
    ////console.log('ANALYTICS - send to ga: ' + newRoute);


    let ecomm_prodids = '';
    this.cartService.cart.cartProducts.forEach(prod => {
      if (prod.idProduct) {
        ecomm_prodids += prod.idProduct.toString() + ',';
      }
    });


    // fbq('track', 'PageView');
    //console.log('FACEBOOK PIXEL - send to fbq: \'track\', \'PageView\'');
    // this.angulartics2Facebook.eventTrack('track', 'PageView');
    //console.log('FACEBOOK PIXEL - send to fbq: \'track\', \'PageView\'');



    //     // this.angulartics2.eventTrack.next({ action: 'View page', properties: { category: newRoute } });
    //     // this.angulartics2.settings.pageTracking.trackRelativePath = true;
    //     // this.angulartics2.pageTrack.subscribe((x: any) => this.pageTrack(x.path));
    //     // this.angulartics2.eventTrack.subscribe((x: any) =>
    //     //   ga('send', 'pageview', x.path)
    //     // );

  }


  ngOnInit() {

    ////console.log('ngOnInit');

    if (this.session.isLogged()) {
      ////console.log('UTENTE isLogged : utilities.AutoLogin');
      ////console.log(this.session.sessionState);
      this.utilities.AutoLogin(this.session.sessionState);
    }

    ////console.log('ngOnInit - app.component');
    this.responsive.mediaChange.subscribe(media => {
      this.media = media;
      this.isXS = media === 'xs';
    });

    this.activatedRoute.params.subscribe((params: Params) => {
      if (params['paramsTable']) {
        this.table = 'Navbar' + params['paramsTable'];

        ////console.log('paramsTable: ' + this.table);
      }
    });

    this.RouteMenu = this.router.config;
    this.cartService.cartCheckProducts();


    if (this.cartService.cart.currentCartProduct) {
      if (!this.cartService.cart.currentCartProduct.config) {
        this.cartService.cart.currentCartProduct.config = this.config.products[0];
      }
    } else {
      this.session.setProduct(this.config.products.filter(x => x.idModel === 9)[0], '', '');
    }

    // this.cartService.saveCart();
    // this.session.getParamTree();
    this.session.setBtnToggle(this.session.params);

    this.router.events.subscribe((route: Event) => {
      if (route instanceof NavigationEnd) {
        this.sendAnalytics();
        window.scrollTo(0, 0);
        $('html, body').animate({ scrollTop: 0 }, 'slow');
      }
    });

    this.sendAnalytics();

  }


  ShowPREVButton(): boolean {
    let thisUrl = this.router.url.toString();
    if (thisUrl.indexOf('select-products') > -1) {
      return false;
    } else {
      return true;
    }
  }
  ShowNEXTButton(): boolean {
    let thisUrl = this.router.url.toString();
    if (thisUrl.indexOf('checkout') > -1 || thisUrl.indexOf('pagecrop') > -1) {
      return false;
    } else {
      return true;
    }
  }


  IdStep(): string {
    this.table = this.router.url.substring(1);
    let thisButton = this.config.btnToggles.filter(r => r.url === this.table)[0];

    if (thisButton) {
      return (this.config.btnToggles.indexOf(thisButton) + 1).toString();
    } else {
      let thisUrl = this.router.url.toString();
      if (thisUrl.indexOf('checkout') > -1) {
        return 'checkout';
      } else if (thisUrl.indexOf('cart') > -1) {
        return 'cart';
      } else if (thisUrl.indexOf('pagecrop') > -1) {
        return 'ritaglio';
      } else { return ''; }
    }
  }

  PrevStep() {
    this.table = this.router.url.substring(1);
    let thisSlideSort = 0;
    let thisButton = this.config.btnToggles.filter(r => r.url === this.table)[0];

    let thisUrl = this.router.url.toString();
    if (thisUrl.indexOf('checkout') > -1) {
      this.cambiaSlide('cart');
    } else if (thisUrl.indexOf('cart') > -1) {
      this.cambiaSlide('preview');
    }

    if (thisButton) {
      thisSlideSort = thisButton.sort;
      let NextUrl = this.config.btnToggles.filter(r => r.sort < thisSlideSort).reverse();

      if (NextUrl[0]) {
        this.cambiaSlide(NextUrl[0].url);
      } /*else {
        this.cambiaSlide('preview');
      }*/
    }
    // else if (thisUrl.indexOf('slide-parameter') > -1)
    // {
    //   this.cambiaSlide('preview');
    // }
  }

  NextStep() {
    ////console.log('this.config.btnToggles', this.config.btnToggles);

    this.table = this.router.url.substring(1);
    let thisSlideSort = 0;
    let thisButton = this.config.btnToggles.filter(r => r.url === this.table)[0];
    let thisUrl = this.router.url.toString();

    if (thisButton) {
      thisSlideSort = thisButton.sort;
      let NextUrl = this.config.btnToggles.filter(r => r.sort > thisSlideSort);
      if (NextUrl[0]) {
        this.cambiaSlide(NextUrl[0].url);
      } else if (thisUrl.indexOf('preview') > -1) {
        this.cambiaSlide('cart');
      } else {
        this.cambiaSlide('preview');
      }
    } else if (thisUrl.indexOf('cart') > -1) {
      this.cambiaSlide('checkout');
    }

  }

  cambiaSlide(link) {

    if (this.router.url !== ('/' + link)) {
      this.classe = 'inactive';
      this.router.navigate(['/' + link]);
      this.classe = 'active';

      window.scrollTo(0, 0);
      // SCROLL IN BASSO SULLA SLIDE
      // let posY = $('.slide').offset().top;
      // $('html, body').animate({ scrollTop: posY }, 'slow');

    }
    this.showHideNav = false;
  }

  toggleSlide(cmp) {
    if (this.classe === 'active') { this.classe = 'inactive'; } else { this.classe = 'active'; }
  }

  isDisabled(text: string, parameter: boolean) {
    if (this.session.params && this.session.params.length !== 0) {
      let thisParam = this.session.params.filter(p => p.table === text && p.reportTable === 'Navbar')[0];
      let result = '';
      if (parameter && thisParam.type === 'Hidden' && thisParam.table !== 'NavbarFormato') {
        result = 'hidden';
      }
      return result;
    }
    return 'hidden';
  }
}







// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/app.component.ts